import { Observable } from 'rxjs';

import {
  DataCloudFlightSelectionData,
  DataCloudIdentityData,
  OfferListFetchParams,
  PreFlightSearchParams,
  DestinationClickTarget,
} from '../../interfaces';

export abstract class DataCloudService {
  abstract preFlightSearch(data: PreFlightSearchParams): void;

  abstract flightSearch(data: OfferListFetchParams): void;

  abstract flightSelectionSelect(data: DataCloudFlightSelectionData[]): void;

  abstract paxDetails(data: DataCloudIdentityData): void;

  abstract mmbPaxDetails(data: DataCloudIdentityData): void;

  abstract signupPaxDetails(data: DataCloudIdentityData): void;

  abstract subscriberId(subscriberId: string): void;

  abstract completePurchase(destination: string): void;

  abstract destinationListDestinationClick(origin: string, destination: string, target: DestinationClickTarget): void;

  abstract allDestinationsPageDestinationClick(origin: string, destination: string): void;

  abstract destinationListAllDestinationsClick(): void;

  abstract getAnonymousId(): Observable<string>;
}
